import styled, { css } from "styled-components";

const tooltipsprops = {
  success: css`
    background: var(--success);
    color: var(--success-text);
  `,
  error: css`
    background: var(--error);
    color: var(--error-text);
  `,
  info: css`
    background: var(--info);
    color: var(--info-text);
  `,
};

const tooltipsBeforeprops = {
  success: css`
    background: var(--success) transparent;
    border-color: var(--success) transparent;
  `,
  error: css`
    background: var(--error) transparent;
    border-color: var(--error) transparent;
  `,
  info: css`
    background: var(--info) transparent;
    border-color: var(--info) transparent;
  `,
};

const tooltipsIconprops = {
  success: css`
    color: var(--success);
  `,
  error: css`
    color: var(--error);
  `,
  info: css`
    color: var(--info);
  `,
};

interface itooltipsprops {
  type: "success" | "error" | "info";
}

export const Container = styled.div<itooltipsprops>`
  position: relative;

  span {
    padding: 8px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    opacity: 0;
    transition: 0.4s;
    background: var(--grey);
    position: absolute;
    bottom: calc(100% + 12px);
    width: 160px;
    left: 50%;
    transform: translateX(-50%);
    visibility: hidden;

    ${(props) => tooltipsprops[props.type || "info"]}

    &::before {
      content: "";
      border-style: solid;

      border-width: 6px 6px 0 6px;
      top: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);

      ${(props) => tooltipsBeforeprops[props.type || "info"]}
    }
  }

  svg {
    ${(props) => tooltipsIconprops[props.type || "info"]}
  }

  &:hover span {
    opacity: 1;
    visibility: visible;
  }
`;
